<template>
  <layout-page>
    <div class="mx-auto justify-center bg-repeat lg:bg-hero-tile">
      <div
        class="w-full bg-home bg-no-repeat lg:h-[538px] lg:border-b lg:border-solid lg:border-grey-20 lg:bg-hero-970 lg:pt-[100px] xl:h-[629px] xl:bg-hero-desktop xl:pt-[195px]"
      >
        <div class="container">
          <h1
            class="py-4 text-center text-2xl font-medium text-blue-60 lg:text-left lg:text-3xl"
          >
            The <span class="font-bold">fast</span> and
            <span class="font-bold">easy</span> way to find a recruitment
            agency.
          </h1>
          <p class="hidden text-grey-70 lg:mb-6 lg:block lg:pl-2 lg:text-xl">
            Helping
            <span class="font-bold text-green">{{ employerCount }}</span>
            employers and
            <span class="font-bold text-green">{{ candidateCount }}</span>
            candidates since 2000
          </p>
        </div>
        <div class="w-full lg:container lg:px-0">
          <search-bar
            page-type="search"
            :job_type="parameters.job_types && parameters.job_types[0]"
            :industry="parameters.industry"
            :location="currentLocationOption"
            :skill="parameters.skill"
            :skill-options="getSearchbarSkillOptions(parameters.industry)"
            :emp_cand="parameters.emp_cand"
          />
        </div>
      </div>

      <div class="container">
        <div
          class="m-6 flex flex-col items-center border border-grey-20 bg-white p-8 text-lg text-blue lg:-mt-12"
        >
          <p class="pb-2 text-center">
            Want the fast and easy way to find a recruitment agency?
          </p>
          <p class="text-center">
            Use Agency Central to search more than 8,000 UK agencies - in
            seconds.
          </p>
        </div>
      </div>
    </div>
  </layout-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AcCard from 'Components/AcCard.vue';
import NavBar from 'Components/NavBar/NavBar';
import SearchBar from 'Components/SearchBar';
import LayoutPage from 'Components/layouts/LayoutPage';
import IconLogoGraphic from 'Components/Icons/IconLogoGraphic';
import InputButton from 'Components/InputButton.vue';

export default {
  name: 'SearchForAgencies',
  components: {
    InputButton,
    IconLogoGraphic,
    LayoutPage,
    AcCard,
    SearchBar,
    NavBar,
  },
  methods: {
    ...mapActions('info', ['loadInfo']),
    ...mapActions('search', ['resetState']),
  },
  computed: {
    ...mapGetters('industry', ['getSearchbarSkillOptions']),
    ...mapGetters('search', ['currentLocationOption']),
    ...mapState('search', ['parameters']),
    ...mapState('info', ['candidateCount', 'employerCount', 'loaded']),
  },
  mounted() {
    if (!this.loaded) {
      this.loadInfo();
    }
    // Reset the search state on homepage load
    this.resetState();
  },
};
</script>
